import type { IBrandReview } from '../redux/buzzbridge/brandReview.types';

export interface IBrandReviewsPage {
    reviews: IBrandReview[];
    totalCount: number;
    currentPage: number;
    totalPages: number;
    pageSize: number;
}

/** Pure unwrap helper — HTTP lives in buzzbridge saga. */
export function unwrapBrandReviewsList(response: any): IBrandReviewsPage {
    const body = response?.data ?? response;
    const nested = body?.data?.data ?? body?.data ?? [];
    const reviews = Array.isArray(nested) ? nested : [];
    return {
        reviews,
        totalCount: Number(body?.totalCount ?? reviews.length) || 0,
        currentPage: Number(body?.currentPage ?? 1) || 1,
        totalPages: Number(body?.totalPages ?? 1) || 1,
        pageSize: Number(body?.pageSize ?? reviews.length) || 10,
    };
}
